import { render, staticRenderFns } from "./pagination-record.vue?vue&type=template&id=a9deadae&"
import script from "./pagination-record.vue?vue&type=script&lang=js&"
export * from "./pagination-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9deadae')) {
      api.createRecord('a9deadae', component.options)
    } else {
      api.reload('a9deadae', component.options)
    }
    module.hot.accept("./pagination-record.vue?vue&type=template&id=a9deadae&", function () {
      api.rerender('a9deadae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pagination-record.vue"
export default component.exports